(function($) {
  "use strict";
  /* ---------------------------------------------
    Instagram
   --------------------------------------------- */
  function instagram(){
    if(typeof accessToken !== 'undefined'){
      $.ajax({
        url: 'https://api.instagram.com/v1/users/self/media/recent',
        type: 'GET',
        dataType: 'jsonp',
        contentType: 'application/json',
        cache: false,
        data: {
          access_token: accessToken
        },
        success: function(responsive) {
          var is_json = false;
          try {
            if (responsive.meta.code == 200)
              is_json = true;
          } catch (ex) {
            is_json = false;
          }
          if (is_json) {
            var html = '';
            var data = responsive.data;
            $.each(data,function(index,element){
              if(index >= insta_limit ) return 0;
              html += '<a class="banner-effect1" href="'+element.link+'"><img src="'+(element.images.thumbnail.url).replace('s150x150',insta_size)+'" alt=""></a>';

            });
            $("#list-image").html(html);
          }
        }
      });
    }
  }
  
  /* ---------------------------------------------
  Single product page
   --------------------------------------------- */
  
  //Single product page
  var templateSinglePr = 'product-template';
  window.initThumbnailSlider = function(template) {
    if(template == 'qv'){
      templateSinglePr = 'quickview-template';
    }
    var vertical = false,
        ce_Padding = '0px',
        infinite = true,
        items = 4;
    if($('.productThumbSlide--'+templateSinglePr).attr('data-vertical') === "true"){
      vertical = true;
      items = 3;
      ce_Padding = '0px';
    }
    if(vertical == false && $('.productThumbSlide--'+templateSinglePr+' .product-single__thumbnails-item').length <= 4 ){
      $('.productThumbSlide--'+templateSinglePr).addClass('noCenterMode');
      infinite: false;
    }
    var options = {
      slidesToShow: items,
      infinite: infinite,
      prevArrow: '.thumbnails-slider__prev--'+templateSinglePr,
      nextArrow: '.thumbnails-slider__next--'+templateSinglePr,
      vertical: vertical,
      verticalSwiping: vertical,
      centerMode:false,
      centerPadding: ce_Padding,
      asNavFor: '.product-single__photos-'+templateSinglePr,
      responsive: [{
        breakpoint: 1023,
        settings: {
          adaptiveHeight: true,
          slidesToShow: 3,
          vertical: false,
          verticalSwiping: false,
          centerPadding: '0px'
        }
      }]
    }
    $(".product-single__thumbnails-"+templateSinglePr).slick(options);
  };
  window.destroyThumbnailSlider = function(template) {
    if(template == 'qv'){
      template = 'quickview-template';
    }
    $('.product-single__thumbnails-'+template).slick('unslick');
  }
  window.initPhotoSlider = function(template) {
    if(template == 'qv'){
      templateSinglePr = 'quickview-template';
    }
    if($('#ProductSection-'+templateSinglePr).data('use-thumb') === true){
      var options = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.product-single__thumbnails-'+templateSinglePr
      };
    }
    else {
      var options = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
        fade: true,
        cssEase: 'linear'
      };
    }
    $(".product-single__photos-"+templateSinglePr).slick(options);
    $('#ProductSection-' +templateSinglePr+' .images').removeAttr("style");
    if (Modernizr.touch == false){
      $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery').trigger('zoom.destroy'); // remove zoom
      $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery').zoom({url: $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery .product-single__photos-item.slick-active').attr('data-src')});
    }
  };
  window.destroyPhotoSlider = function(template) {
    if(template == 'qv'){
      template = 'quickview-template';
    }
    $('.product-single__photos-'+template).slick('unslick');
  }
  
  /* ---------------------------------------------
  Scrollbar header sidebar
   --------------------------------------------- */
  function scrollbar_header_sidebar(){
    //  Scrollbar
    if($('.sidebar-menu').length >0 ){
      $(".sidebar-menu").mCustomScrollbar();
    }
    if($('.header-categoy-menu .inner').length >0 ){
      $(".header-categoy-menu .inner").mCustomScrollbar();
    }
    if($('.header .categorys-menu').length >0){
      if($(window).width() <= 768){
        $(".header .categorys-menu").mCustomScrollbar({
          axis:"x",
          theme:"dark-thin",
          autoExpandScrollbar:false,
          advanced:{autoExpandHorizontalScroll:true}
        });
      }
      else{
        $(".header .categorys-menu").mCustomScrollbar("destroy")
      }
    }
    if($('.searchDrop .isGroup ul').length >0){
      if($(window).height() > 230){
        $('.searchDrop .isGroup ul').mCustomScrollbar({
          axis:"y",
          theme:"dark-thin",
          autoExpandScrollbar:false,
          autoHideScrollbar:true,
          scrollbarPosition: "inside",
          scrollInertia: 400,
          advanced:{autoExpandHorizontalScroll:true}
        });
      }
    }
    if($('.show-shopping-cart').length >0){
      if($(window).height() > 500){
        $('.show-shopping-cart').mCustomScrollbar({
          axis:"y",
          theme:"dark-thin",
          autoExpandScrollbar:false,
          autoHideScrollbar:true,
          scrollbarPosition: "outside",
          scrollInertia: 400,
          advanced:{autoExpandHorizontalScroll:true}
        });
      }
    }
  }

  /* ---------------------------------------------
  SEARCH
   --------------------------------------------- */
  var $current_search = null,
      $val = '',
      $typeSearch = '',
      $url = '',
      scrollDropSearch = function(){
        if($('.livesearchDrop').length > 0){
          $('.livesearchDrop').mCustomScrollbar({
            axis:"y",
            theme:"dark-thin",
            autoExpandScrollbar:false,
            autoHideScrollbar:true,
            scrollbarPosition: "inside",
            scrollInertia: 400,
            advanced:{autoExpandHorizontalScroll:true}
          });
        }
      },
      ajaxSearch = function(element){
        $val = element.val();
        var $this = element.parents('form.box-search');
        $this.find('.livesearchDrop').mCustomScrollbar("disable",true);
        clearTimeout($current_search);
        if($this.find($("li span.selected")).attr("data-value") === "all"){
          $(".iconSearchDrop").removeClass('isFilter');
          $typeSearch = '';
        }
        else if($this.find($("li span.selected")).attr("data-value") === "article"){
          $(".iconSearchDrop").addClass('isFilter');
          $typeSearch = 'type=article';
        }
        else if($this.find($("li span.selected")).attr("data-value") === "page"){
          $(".iconSearchDrop").addClass('isFilter');
          $typeSearch = 'type=page';
        }
        else if($this.find($("li span.selected")).attr("data-value") === "product"){
          $(".iconSearchDrop").addClass('isFilter');
          $typeSearch = 'type=product';
        }
        else{
          $typeSearch = 'type=product';
          $(".iconSearchDrop").addClass('isFilter');
          if($this.find($("li span.selected")).attr("data-value") !== ''){
            $val = $this.find($("ul ul li span.selected")).attr('data-cll') + $this.find($("input.search")).val();
          }
        }
        if($val.trim() == '') {
          $this.removeClass('loading').removeClass('loaded');
          $this.find(".livesearch").html('');
          return false;
        }else{
          $this.find(".livesearch").html('');
          $url = $typeSearch.length > 0 ? encodeURI("/search?q="+$val+"&"+$typeSearch+"&view=ajax".replace(/\s/g,'+')) : encodeURI("/search?q="+$val+"&view=ajax".replace(/\s/g,'+'));
          $this.addClass('loading').removeClass('loaded');
          $current_search = setTimeout(function(){
            $.get($url, function(data) {
            // console.log(data)
              if($(data).find('.thumb').length === 0 ){
                  $this.removeClass('loading').addClass('loaded');
                  $this.find(".livesearch").html(data);
              }
              else{
                $this.find(".livesearch").html(data);
                $this.find(".item-search").each(function(i) {
                  var t = $(this);
                  var style = $(this).attr("style");
                  style = (style == undefined) ? '' : style+";";
                  var delay = i * 20 + 1 * 50;
                  var animate = t.data('animate');
                  t.attr("style", style +
                         "-webkit-animation-delay:" + delay + "ms;" + "-moz-animation-delay:" + delay + "ms;" + "-o-animation-delay:" + delay + "ms;" + "animation-delay:" + delay + "ms;"
                        ).addClass('animated ' + animate).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                    $(this).removeClass('animated ' + animate);
                  });
                  if(i == $this.find(".item-search").length - 1){
                    $this.removeClass('loading').addClass('loaded');
                    if ($this.find(".livesearch .shopify-product-reviews-badge").length > 0 ) {
                      return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                    }
                  }
                })
              }
              Currency.convertAll(shopCurrency,cookieCurrency,".livesearch span.money");
              if($this.find('.livesearchDrop .mCustomScrollBox').length <= 0){
                scrollDropSearch();
              }
              else{
                $this.find('.livesearchDrop').mCustomScrollbar("update");
              }
            });
          },700);
        }
      };
  
  /* ---------------------------------------------
    Search By cattegories
  kitisummus@gmail.com
   --------------------------------------------- */
  function kt_search(){
    //Search Box
    $(document).on('submit', "form.box-search", function(event){
      var $this = $(this);
      if($this.find($("li span.selected")).attr("data-value") === "all"){
        $("input.inputType").removeAttr('name');
        return;
      }
      else if($this.find($("li span.selected")).attr("data-value") === "article"){
        $("input.inputType").attr({'name':'type','value':'article'});
        return;
      }
      else if($this.find($("li span.selected")).attr("data-value") === "page"){
        $("input.inputType").attr({'name':'type','value':'page'});
        return;
      }
      else if($this.find($("li span.selected")).attr("data-value") === "product"){
        $("input.inputType").attr({'name':'type','value':'product'});
        return;
      }
      else{
        $("input.inputType").attr({'name':'type','value':'product'});
        if($this.find($("li span.selected")).attr("data-value") !== ''){
          var inputValue = $this.find($("ul ul li span.selected")).attr('data-cll') + $this.find($("input.search")).val();
          $("input.search").val(inputValue);
        }
        return;
      }
      event.preventDefault();
    });

    $(document).on("keyup","input.search", function(event){
      event.preventDefault();
      $("input.search").not($(this)).val($(this).val());
    });

    $(document).on("click", "form.box-search .searchDrop li span", function(event){
      event.preventDefault();
      if($(this).hasClass(".titleGroup") == false){
        $("form.box-search").find(".selected").removeClass("selected");
        $(this).addClass("selected");
        var inputName = $(this).attr('data-value');
        var inputValue = $(this).parents('form.box-search').find('input.search');
        $("input.inputType").attr('value',inputName);
        if( inputValue.val().trim() != '' ){
          $(this).parents('form.box-search').removeClass('showCatt');
          ajaxSearch(inputValue);
        }
      }
    });

    //Search By cattegories
    $(".box-search input.search").bind('focus',function(e) {
      $(this).parents('.box-search').addClass('focus');
    });

    $('body').on('click', '.iconSearchDrop', function(event) {
      event.preventDefault();
      $(this).parents('.box-search').toggleClass('showCatt');
    });

    $('body').on('click', 'input.search', function(event) {
      event.preventDefault();
      $(this).parents('.box-search').removeClass('showCatt');
    });
    
    $('input.search').keypress(function(evt){
      if(evt.which == 13) {
        jQuery('.iconSearchDrop').trigger('click');
        $(this).closest('form').submit();
      }
    });

    $(document).on('click', function(e){ 
      if ($(e.target).is('.box-search') === false && $(e.target).is('.box-search input') === false && $(e.target).is('.iconSearchDrop svg') === false && $(e.target).is('.box-search *') === false) {
        $('.box-search').removeClass('focus').removeClass('showCatt').removeClass('loaded');
      }
    });
  }
  
  $(document)
  .on('shopify:section:load', kt_search)
  .on('shopify:section:unload', kt_search)
  .on('shopify:section:select', kt_search)
  .on('shopify:section:deselect', kt_search)
  .on('shopify:block:select', kt_search)
  .on('shopify:block:deselect', kt_search);
  
  /* ---------------------------------------------
   QUICKVIEW
   --------------------------------------------- */
  function kt_quickView(){
    $('body').on('click', '.product-item .quick-view', function(event) {
      event.preventDefault();
      var url = $(this).attr('data-view');
      var $this = $(this);
      var html = '<div class="look-page-loading">Loading....</div>';
      $.ajax({
        url: url+'?view=quickView',
        type: 'GET',
        beforeSend:function(){
          $('.product-quickview-content').addClass('loading');
          $('body').append(html);
        },
        success: function(data){
          $('.product-quickview-content').html(data);
          var sections = new theme.Sections();
          sections.register('productQuickview', theme.Product);
          var images = $('.product-quickview-content .SlickPhotoswipGallery');
          var loadedImgNum = 0;
          images.imagesLoaded().progress( function() {
            loadedImgNum += 1;
            console.log(loadedImgNum);
            if(images.length > 1 && loadedImgNum == 2){
              $("#myModal").modal();
              $('.look-page-loading').remove();
            }
            else if(loadedImgNum == 1){
            $("#myModal").modal();
              $('.look-page-loading').remove();
            }
          })
          .done( function() {
            setTimeout(function(){
              $('.product-quickview-content').removeClass('loading');
              initPhotoSliderQv('qv');
              initThumbnailSliderQv('qv');
              // Function in snippet/singleProduct_script.liquid
              if ($(".product-quickview-content .shopify-product-reviews-badge").length > 0 ) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
            }, 900);

            setTimeout(function(){
              if ($(window).width() > 767 ) {
                $('.product-quickview-content .product-details-right').css('height',$('.product-quickview-content .product-images').height()+'px').mCustomScrollbar({
                  axis:"y",
                  theme:"dark-thin",
                  autoExpandScrollbar:false,
                  autoHideScrollbar:true,
                  scrollbarPosition: "outside",
                  scrollInertia: 100,
                  advanced:{autoExpandHorizontalScroll:true}
                });
              }
            },1000)
            theme.Quantity();
            theme.DropdownReposive.init('#ProductSection-quickview-template .fake_select>ul','.color_sw','.title');
          });
        }
      });
    });
  }
  if($('.quick-view').length > 0){
    $(document)
    .on('shopify:section:load', kt_quickView)
    .on('shopify:section:unload', kt_quickView)
    .on('shopify:section:select', kt_quickView)
    .on('shopify:section:deselect', kt_quickView)
    .on('shopify:block:select', kt_quickView)
    .on('shopify:block:deselect', kt_quickView);
  }

  /* ---------------------------------------------
   QUICKVIEW
   --------------------------------------------- */
  function kt_quickShop(){    
    $('body').on('click', '.product-item .quick-shop', function(event) {
      event.preventDefault();
      var url = $(this).attr('data-href');
      var $this = $(this);
      var addButton = $this.attr('class').replace(' quick-shop','').replace(/ /g, ".");
      if($this.parents('.product-item').find('.product-page').length > 0){
        if($this.parents('.product-item').hasClass('smallQuickshop')){
          $('#quickShopModal').modal();
        }
        else{
          $this.parents('.product-item').addClass('showQuickShop');
          $this.parents('.product-item').find('.'+addButton).removeClass('hidden');
          $this.addClass('hidden');
          $this.parents('.product-item').find('button.close').attr('data-button',$this.attr('class').replace(' quick-shop hidden',''));
        }
      }
      else{
        $.ajax({
          url: url+'?view=variantQuickShop',
          type: 'GET',
          dataType: 'html'
        })
        .done(function(data) {
          var css = data.split('<!--ENDCSS-->')[0];
          if($this.parents('.product-item').find('.variantQuickShop').length <= 0){
            $this.parents('.product-item').append('<style class="variantQuickShop">'+css+'</style>');
          }
          var json = data.split('<!--ENDHTML-->')[1];
          var html = data.split('<!--ENDCSS-->')[1].split('<!--ENDHTML-->')[0] + '<script type="application/json" id="ProductJson-'+$this.attr('data-pid')+'">' + json + '</script>';
          if($this.parents('.product-item').hasClass('smallCard')){
            $('#quickShopModal .product-quickshop-content').html(html);
            $('#quickShopModal').modal();
            $('#quickShopModal .product-quickshop-content').mCustomScrollbar({
              axis:"y",
              theme:"dark-thin",
              autoExpandScrollbar:false,
              autoHideScrollbar:true,
              scrollbarPosition: "outside",
              scrollInertia: 100,
              advanced:{autoExpandHorizontalScroll:true}
            });
          }
          else{
            $this.parents('.product-item').addClass('showQuickShop')
            $this.parents('.product-item').find('.'+addButton).removeClass('hidden');
            $this.addClass('hidden');
            $this.parents('.product-item').find('.quickshopForm').html(html);
            $this.parents('.product-item').find('button.close').attr('data-button',$this.attr('class').replace(' quick-shop hidden',''));
            $this.parents('.product-item').find('.product-page').mCustomScrollbar({
              axis:"y",
              theme:"dark-thin",
              autoExpandScrollbar:false,
              autoHideScrollbar:true,
              scrollbarPosition: "outside",
              scrollInertia: 100,
              advanced:{autoExpandHorizontalScroll:true}
            });
          }
          var sections = new theme.Sections();
          sections.register('product-'+$this.attr('data-pid'), theme.Product);
          theme.DropdownReposive.init('#ProductSection-'+$this.attr('data-pid')+' .fake_select>ul','#ProductSection-'+$this.attr('data-pid')+' .fake_select>ul .color_sw','#ProductSection-'+$this.attr('data-pid')+' .fake_select>ul .title');
          theme.Quantity();
        })
      }
    })
    $('body').on('click', '.quickshopForm button.close', function(event) {
      var button = $(this).attr('data-button').replace(/ /g, ".");
      $(this).parents('.product-item').removeClass('showQuickShop')
      $(this).parents('.product-item').find('.'+button).not(".quick-shop").addClass('hidden');
      $(this).parents('.product-item').find('.quick-shop.'+button).removeClass('hidden');
      var parentWidth = $(this).parents('.product-item').width();
      if(parentWidth < 230){
        $(this).parents('.product-item').find('.quickshopForm').html('');
        $(this).parents('.product-item').find('.variantQuickShop').remove();
      }
    });
  }
  
  /* ---------------------------------------------
   COUNTDOWN
   --------------------------------------------- */
  window.kt_countdown = function(){
    if($('.kt-countdown').length >0){
      $('.kt-countdown').each(function() {
        var $this = $(this);
        $(this).countdown($(this).data('y')+'/'+$(this).data('m')+'/'+$(this).data('d'),{elapse:true}).on('update.countdown', function(event) {
          if (event.elapsed) { // Either true or false
            // Counting up...
            $this.parent('.product-count-down').hide();
          } else {
            // Countdown...
            $this.html(
              event.strftime(''
                             + '<span class="box-count day"><span class="number">%-D</span> <span class="text">Day%!D</span></span><span class="dot">:</span>'
                             + '<span class="box-count hrs"><span class="number">%H</span> <span class="text">Hr%!H</span></span><span class="dot">:</span>'
                             + '<span class="box-count min"><span class="number">%M</span> <span class="text">Min%!M</span></span><span class="dot">:</span>'
                             + '<span class="box-count secs"><span class="number">%S</span> <span class="text">Sec%!S</span></span>')
            );
          }
        });
      });
    }
  }
  function getScrollbarWidth() {
    var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
        $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
        inner = $inner[0],
        outer = $outer[0];
    jQuery('body').append(outer);
    var width1 = inner.offsetWidth;
    $outer.css('overflow', 'scroll');
    var width2 = outer.clientWidth;
    // $outer.remove();
    return (width1 - width2);
  }
  
  /* ---------------------------------------------
   MASORY FILTER
   --------------------------------------------- */
  window.MasoryFilter = function() {
    if($('#layered_form--slick .masory_layout').length > 0 && $(window).width() >= 768){
      var $grid = $('#layered_form--slick .masory_layout').isotope({
        itemSelector: '.layered_filter',
        horizontalOrder: true,
        layoutMode: 'packery',
        transitionDuration: '.8s'
      }).addClass('initialized');
      $grid.imagesLoaded().progress( function() {
        $grid.isotope('layout');
      });
    }
    if($('.layered_filter_ul').length > 0){      
      $('.layered_filter_ul').not('.ul_layered_id_tags, .ul_layered_availability, .ul_layered_price_0, .layered_filter_sort_by').each(function(){
        $(this).mCustomScrollbar({
          axis:"y",
          theme:"dark-thin",
          autoExpandScrollbar:false,
          autoHideScrollbar:true,
          scrollbarPosition: "outside",
          scrollInertia: 200,
          advanced:{autoExpandHorizontalScroll:true}
        });
      });
    }
  }
  
  /* ---------------------------------------------
   PARALLAX BANNER
   --------------------------------------------- */
  function kt_parallax(){
    //parallax
    var window_size = $(window).width();
    window_size += getScrollbarWidth();
    $('.bg-parallax').each(function(){
      (Modernizr.touch) ? $(this).addClass('isMoblideParallax') : $(this).removeClass('isMoblideParallax'); 
      if( window_size > 991 ){
        $(this).parallax('50%', 0.3);
      }
    });
    if($('.block-paralax3 .bg-parallax_child1').length > 0){
      $('.block-paralax3 .bg-parallax_child1').parallax('10%', 0.2);
    }
  }
  $(document)
  .on('shopify:section:load', kt_parallax)
  .on('shopify:section:unload', kt_parallax)
  .on('shopify:section:select', kt_parallax)
  .on('shopify:section:deselect', kt_parallax)
  .on('shopify:block:select', kt_parallax)
  .on('shopify:block:deselect', kt_parallax);
  
  /* ---------------------------------------------
   PARALLAX BANNER
   --------------------------------------------- */
  function customize_error(){
    $('#error_html .errors').detach().appendTo('.error_html_clone');
  }
  $(document)
  .on('shopify:section:load', customize_error)
  .on('shopify:section:unload', customize_error)
  .on('shopify:section:select', customize_error)
  .on('shopify:section:deselect', customize_error)
  .on('shopify:block:select', customize_error)
  .on('shopify:block:deselect', customize_error);
  
  /* ---------------------------------------------
  BANNER
   --------------------------------------------- */
  function kiti_banner_get_scrollbar_width() {
    var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
        $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
        inner = $inner[0],
        outer = $outer[0];
    jQuery('body').append(outer);
    var width1 = inner.offsetWidth;
    $outer.css('overflow', 'scroll');
    var width2 = outer.clientWidth;
    $outer.remove();
    return (width1 - width2);
  }
  function kiti_banner(){
    //Shortcode Banner
    $('.kt-banner').each(function(){
      var window_size = jQuery('body').innerWidth();
      window_size += kiti_banner_get_scrollbar_width();
      var minHeight = $(this).data('height'),
          bgimg = $(this).data('background'),
          bgcolor = $(this).data('bgcolor');
      var bgcontainer =  $(this).find('.bg-image');
      var content = $(this).find('.content');
      var reponsive = $(this).data('reponsive');
      bgcontainer.css({
        'min-height':minHeight+'px',
        'height':minHeight+'px'
      });

      if( typeof (bgimg)!= 'undefined' && bgimg !=""){
        bgcontainer.css({
          'background-image':'url('+bgimg+')'
        });
      }

      if( typeof (bgcolor) != 'undefined' && bgcolor !=""){
        bgcontainer.css({
          'background-color':bgcolor
        });
      }

      if (typeof(reponsive) != 'undefined'){
        //console.log(window_size);
        for (var k in reponsive){
          if (typeof reponsive[k] !== 'function') {
            if( window_size <= k ){
              if( reponsive[k] > 0 ){
                bgcontainer.css({
                  'min-height':reponsive[k]+'px',
                  'height':reponsive[k]+'px'
                });
                break;
              }
            }
          }
        }
      }
    });
  }
  kiti_banner();
  $(document)
  .on('shopify:section:load', kiti_banner)
  .on('shopify:section:unload', kiti_banner)
  .on('shopify:section:select',kiti_banner)
  .on('shopify:section:deselect', kiti_banner)
  .on('shopify:block:select',kiti_banner)
  .on('shopify:block:deselect', kiti_banner);
  
  /* ---------------------------------------------
   WISHLIST
   --------------------------------------------- */
  // Add wishlist
  function addwishlist() {
    $("body").on('click', '.add_nitro_wishlist', function(event) {
      event.preventDefault();
      var $this = $(this),
          holder = $this.parent().siblings('.yith-wcwl-add-button'),
          load = $this.parent().find('.load_nitro_wishlist'),
          added = $this.parent().find('.added_nitro_wishlist');
      $this.hide();
      load.show();
      $.ajax({
        url: 'https://nitro-wishlist.teathemes.net?shop='+ Shopify.shop,
        type: 'POST',
        data: $this.data(),
        success: function(data, status) {
          try {
            data = $.parseJSON(data);
          } catch(ex) {
            //console.log(ex);
          }
          if(data.status == 'success' && status == 'success') {
            added.show();
            load.hide();
            $this.hide();
            $('.gl_count_wishlist').html(function(i, val) {
              return val * 1 + 1
            });
          } else {
            load.hide();
            $this.show();
            console.log('ajax error');
          }
        },
        error: function(data) {
          load.hide();
          $this.show();
          console.log('ajax error');
        },
      });
    });
  }
  // Remove wishlist
  function removewishlist() {
    $("body").on('click', '.nitro_wishlist_remove', function(event) {
      event.preventDefault();
      var $this = $(this),
          value = $(this).data('id');
      $('.wishlist-page .card').css('opacity','1');
      $.ajax({
        url: 'https://nitro-wishlist.teathemes.net?shop='+ Shopify.shop,
        type: 'POST',
        data: $this.data(),
        success: function(data, status) {
          try {
            data = $.parseJSON(data);
          } catch(ex) {
            //console.log(ex);
          }
          if(data.status == 'success' && status == 'success') {
            $('.gl_count_wishlist').html(function(i, val) {
              return val * 1 - 1
            });
            $('#WishItem-' + value).fadeOut(300, function(){
              $(this).remove();
              var rowCount = $('.wishlist-page-items .wishlist-page-item').length;
              if(rowCount == 0) {
                $('.wishlist-page-items')
                .html('<div class="col-md-12"><div class="text-center wishlist-empty">' + theme.wishlist.nowishlist + '</div></div>');
              }
            });
            $('.wishlist-page .card').css('opacity','0');
          } else {
            $('.loader').remove();
            console.log('ajax error');
          }
        },
        error: function(data) {
          $('.loader').remove();
          console.log('ajax error');
        },
      });
    });
  }
  
  /* ---------------------------------------------
   RECENTLY VIEWED
   --------------------------------------------- */
  // Add to recently
  function recentlyViewedAdd() {
    var ls = Currency.cookie.tearead('tea-recent') || '[]';
    ls = JSON.parse(decodeURIComponent(ls) );
    if(product_handle !== null){
      var c = product_handle;
      if(ls.indexOf(c)< 0 ){
        if(ls.length >= 10){
          ls.pop();
        }
        ls[ls.length]= (c);
        ls = JSON.stringify(ls);
        Currency.cookie.teawrite('tea-recent',ls);
      }
    }
  }
  // recentlyViewedListSidebar
  window.recentlyViewedListSidebar = function() {
    if($('.widget_recent_product').length > 0){
      var ls = Currency.cookie.tearead('tea-recent') || '[]';
      ls = JSON.parse(decodeURIComponent(ls) );
      if(ls.length){ 
        //ls = ls.split(',');
        var ls = ls.reverse();
        if(ls.length >= 1){
          $(".widget_recent_product").show();
          $.ajax({
            url: '/pages/recently-viewed-products/'+ls.join(",")+'?q=list-sidebar',
            dataType: 'html',
            type: 'GET',
            success: function(responsive) {
              //console.log(responsive);
              $('.widget_recent_product .product-categories').html(responsive);
            },
            error: function(data) {
              console.log('ajax error');
            },
            complete: function() {
              //currency            
              if (cookieCurrency !== null && cookieCurrency !== shopCurrency) {
                Currency.convertAll(shopCurrency,cookieCurrency,'.product-categories li span.money');
              }
              //product review
              if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
            }
          });
        }
      }
  }
  }
  // recentlyViewedProductSingle
  window.recentlyViewedProductSingle = function() {
    if($('.widget_recent_productSg').length > 0){
      var ls = Currency.cookie.tearead('tea-recent') || '[]';
      ls = JSON.parse(decodeURIComponent(ls) );
      if(ls.length){ 
        //ls = ls.split(',');
        var ls = ls.reverse();
        if(ls.length >= 1){
          $.ajax({
            url: '/pages/recently-viewed-products/'+ls.join(",")+'?q='+product_id+'+'+collection_cr,
            dataType: 'html',
            type: 'GET',
            success: function(responsive) {
              // console.log(responsive);
              if(responsive.length > 2){
                $('.widget_recent_productSg .owl-carousel').html(responsive);
                $(".widget_recent_productSg").show();
              }
            },
            error: function(data) {
              console.log('ajax error');
            },
            complete: function() {
              var $this = $('.widget_recent_productSg .owl-carousel');
              var config = $this.data();
              var owl = $this;
              owl.owlCarousel(config);
              //currency            
              if (cookieCurrency !== null && cookieCurrency !== shopCurrency) {
                Currency.convertAll(shopCurrency,cookieCurrency,'.widget_recent_productSg li span.money');
              }
              //product review
              if ($(".widget_recent_productSg .spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
            }
          });
        }
      }
    }
  }
  $(document)
  .on('shopify:section:load', recentlyViewedProductSingle)
  .on('shopify:section:unload', recentlyViewedProductSingle)
  .on('shopify:section:select',recentlyViewedProductSingle)
  .on('shopify:section:deselect', recentlyViewedProductSingle)
  .on('shopify:block:select',recentlyViewedProductSingle)
  .on('shopify:block:deselect', recentlyViewedProductSingle);
  
  /* ---------------------------------------------
   TOOLBAR
   --------------------------------------------- */
  function stickyToolbar(action) {
    if(action == 'up' && $('#toolbar').hasClass('on-sticky')){
      $('#toolbar').removeClass('on-sticky');
    } else if(action == 'down' && $('#toolbar').not('.on-sticky')){
      $('#toolbar').addClass('on-sticky');
    }
  }
  
  /* ---------------------------------------------
     Category carousel
     --------------------------------------------- */
  function block_category_carousel(){
    $('.function-carousel .owl-carousel').each(function(){
      var config = $(this).data();
      var animateOut = $(this).data('animateout');
      var animateIn = $(this).data('animatein');
      if(typeof animateOut != 'undefined' ){
        config.animateOut = animateOut;
      }
      if(typeof animateIn != 'undefined' ){
        config.animateIn = animateIn;
      }
      var owl = $(this);
      owl.owlCarousel(config);
    });
  }
  $(document)
  .on('shopify:section:load', block_category_carousel)
  .on('shopify:section:unload', block_category_carousel)
  .on('shopify:section:select',block_category_carousel)
  .on('shopify:section:deselect', block_category_carousel)
  .on('shopify:block:select',block_category_carousel)
  .on('shopify:block:deselect', block_category_carousel);
  
  /* ---------------------------------------------
   Responsive item slide
   --------------------------------------------- */
  function responsive_item_slide(){
    $('.slideshow__slide[data-slide-blockId]').each(function(){
      var responsive = $.parseJSON($(this).attr('data-responsive'));
      var responsiveSubtitle = $.parseJSON($(this).attr('data-responsive-subtitle'));
      var blockId = $(this).attr('data-slide-blockId');
      var responsived = '';
      $.map(responsive, function(e, i) {
        responsived = responsived + '@media only screen and (min-width: '+i+'px){'+ '.slideshow__slide--'+blockId +' .slideshow__title{'+ e +'}}';
      })
      $.map(responsiveSubtitle, function(e, i) {
        responsived = responsived + '@media only screen and (min-width: '+i+'px){'+ '.slideshow__slide--'+blockId +' .slideshow__subtitle{'+ e +'}}';
      })
      $(this).append('<style type="text/css">'+(responsived.replace(/\"/g,''))+'</style>');
    })
  }
  $(document)
  .on('shopify:section:load', responsive_item_slide)
  .on('shopify:section:unload', responsive_item_slide)
  .on('shopify:section:select',responsive_item_slide)
  .on('shopify:section:deselect', responsive_item_slide)
  .on('shopify:block:select',responsive_item_slide)
  .on('shopify:block:deselect', responsive_item_slide);

  function AutoloadCompare(){
    var ls = Currency.cookie.tearead('tea-compare');
    if(ls != null){ 
      ls = ls.split(',');
      ls.map(function(index, elem) {
        $(".compare[data-pid='"+index+"']").addClass('added');
          // $(".compare.compare-single[data-pid='"+index+"']").text('Added to compare');
      });
    }
    $('#compare-content .table-responsive').mCustomScrollbar({
      axis:"x",
      theme:"dark-thin",
      autoExpandScrollbar:true,
      scrollbarPosition: "inside",
      scrollInertia: 200,
      advanced:{autoExpandHorizontalScroll:true}
    });
  }
  function AddCompare(){
    $('body').on('click', '.compare', function(event) {
      event.preventDefault();
      /* Act on the event */
      var $this = $(this),
          handle = $this.data('pid'),
          holder = $("#compare-content"),
          ls = Currency.cookie.tearead('tea-compare');
      $this.addClass('loading');
      if(ls != null && ls.length > 1){ 
        ls = ls.split(',');
      }else{
        ls = [];
      }
      if(ls.indexOf(handle)< 0 && $(this).hasClass('added') === false ){
        ls.push(handle);
        if (ls.length > 1) {
          var ls_ = ls.join(',');
          if (ls_.substring(0, 1) == ',') { 
            ls_ = ls_.substring(1);
          }
        }else{
          ls_ = ls.toString();
        }
        Currency.cookie.teawrite('tea-compare',ls_);
      }
      $("#compare-content td").remove();
      ls.map(function(index, elem) {
        if (index !== '' && index !== null) {
          Shopify.KT_getProduct(index,function(data){
            $("#compare-content .tr-remove").append('<td class="product-remove cp-'+data.handle+'" data-pid="'+data.handle+'" ><a href="#" class="remove">Remove</a></td>');
            var html = '';
            html +='<td class="product-images cp-'+data.handle+'"><img src="'+Shopify.KT_resizeImage(data.featured_image,"250x250_crop_center")+'" alt="'+data.title+'">';
            html +='<h3 class="product-name">'+data.title+'</h3>';
            html +='<span class="price">';
            html +='<ins>'+theme.Currency.formatMoney(data.price, theme.moneyFormat)+'</ins>';
            if(data.compare_at_price > data.price ){
                html +='<del>'+theme.Currency.formatMoney(data.compare_at_price, theme.moneyFormat)+'</del>';
            }
            html +='</span>';
            if(data.variants.length > 1){
                html +='<a class="add-to-cart product-options btn-load button" href="'+data.url+'">Select options</a>';
            }else{
                if(data.available){
                    html +='<a href="javascript:void(0);" title="Add to cart" class="button add_to_cart_button" onclick="Shopify.KT_addItem('+data.variants[0].id+',1)">Add to cart</a>';
                }else{
                    html +='<a class="add-to-cart product-options btn-load button" href="'+data.url+'">Sold out</a>';
                }
            }

            html +='</td>';
            $("#compare-content .tr-product-image").append(html);
            $("#compare-content .tr-product-desc").append('<td class="product-description cp-'+data.handle+' text-left"><p>'+(data.description.split('[/short description]')[0].replace('[short description]',''))+'</p></td>');
            $("#compare-content .tr-availability").append('<td class="product-availability cp-'+data.handle+'">'+( data.available ? "<span class=\"in-stock\">In stock</span>" : "<span class=\"in-stock\">Out Of Stock</span>")+'</td>');
          });
        }
      })
      setTimeout(function() {
        if(cookieCurrency !== null && cookieCurrency !== shopCurrency){
          Currency.convertAll(shopCurrency,cookieCurrency,'#compare-content span.money');
        }
        $this.addClass('added').removeClass('loading');
        $("#compare-modal").modal('show');
        $("#compare-content .table-responsive").mCustomScrollbar("update");
      }, 1000);
    });
  }
  function RemoveCompare(){
    $('body').on('click', '#compare-content .product-remove', function(event) {
      event.preventDefault();
      /* Act on the event */
      var $this = $(this),handle = $this.attr('data-pid');
      $('.compare[data-pid="'+handle+'"]' ).removeClass('added');
      var ls = decodeURI(Currency.cookie.tearead('tea-compare'));      
      if(ls != null){ 
        ls = ls.split(',');
      }
      ls = jQuery.grep(ls, function(value) {
        return value != handle;
      });
      ls = $.trim(ls);
      Currency.cookie.teawrite('tea-compare',ls);
      $('.cp-'+handle).remove();
      $("#compare-content .table-responsive").mCustomScrollbar("update");
      if(ls.length === 0 ){ 
         // $("#compare-content").find('tbody').html('<tr class="no-products odd"><td>No products added in the compare table.</td></tr>');
      }
    });
  }

  /* ---------------------------------------------
   SKILL BAR
   --------------------------------------------- */
  function processbar(){
    $('.item-processbar').each(function(){
      var $heightSkill = $(this).attr('data-height'),
          $percentSkill = $(this).attr('data-percent'),
          $bgSkill = $(this).attr('data-bgskill'),
          $bgBar = $(this).attr('data-bgBar');

      $(this).find('.processbar-bg').css({
        "height":$heightSkill,
        "background-color":$bgBar

      });
      $(this).find('.processbar-width').css({
        "height":$heightSkill
      });

      $(this).find('.processbar-width').animate({
        'width':$percentSkill+'%'
      },6000);

      if($bgSkill != ''){
        $(this).find('.processbar-width').css({
          'background-color':$bgSkill
        });
      };
    });
  }
  $(document)
  .on('shopify:section:load', processbar)
  .on('shopify:section:unload', processbar)
  .on('shopify:section:select',processbar)
  .on('shopify:section:deselect', processbar)
  .on('shopify:block:select',processbar)
  .on('shopify:block:deselect', processbar);

  /* ---------------------------------------------
   REAL TIME VISITOR
   --------------------------------------------- */
  function realTimeVisitor(){
    $(function(a){var min = 1,max = $('.counter_real_time').attr('data-counter-max'),t=1,r=max;
       t=Math.ceil(t),
       r=Math.floor(r);
       var o=Math.floor(Math.random()*(r-t+1))+t,
       n=["1","2","4","3","6","10","-1","-3","-2","-4","-6"],
       h="",e="",l=["10","20","15"],h="",e="",M="";
       setInterval(function(){
          if(h=Math.floor(Math.random()*n.length),e=n[h],o=parseInt(o)+parseInt(e),min>=o){
             M=Math.floor(Math.random()*l.length);
             var a=l[M];o+=a
          }
          if(o<1 || o>max ){
             o=Math.floor(Math.random()*(r-t+1))+t;
          }
          $("#number_counter>span").html((parseInt(o)));$('.realTime').show()
       },parseInt($('.counter_real_time').attr('data-interval-time')))
    });
  }
  $(document)
  .on('shopify:section:load', realTimeVisitor)
  .on('shopify:section:unload', realTimeVisitor)
  .on('shopify:section:select',realTimeVisitor)
  .on('shopify:section:deselect', realTimeVisitor)
  .on('shopify:block:select',realTimeVisitor)
  .on('shopify:block:deselect', realTimeVisitor);

  function setCookie(cname, cvalue, exdays, exhours, exminute) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * exhours * exminute * 60 * 1000));
    var expires = (exminute == 0 ? 1 : "expires="+d.toUTCString());
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  function is_mobile(){
    var isMobile = false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
       || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;
    return isMobile;
  }  

  /* ---------------------------------------------
   NEWSLETTER POPUP
   --------------------------------------------- */
  function checkCookieNewsletterPopup() {
    var display = getCookie("kt_popupNewsletter");
    var delay = $('#newsletterModal').attr('data-pause');
    var mobileDisplay = $('#newsletterModal').attr('data-mobile-display');
    if($('#contact_form p.form--success').length <= 0){
      if(mobileDisplay === 'true' && is_mobile() === true && $(window).width() < 768){
        $('#newsletterModal').remove();
      }else{
        $('#hideforever').change(function(){
          if ($(this).is(':checked')) {
            document.cookie = "kt_popupNewsletter=disable;1;path=/";
          } else {
            document.cookie = "kt_popupNewsletter=;path=/";
          }
        });
        if (display != "disable") {
          setTimeout(function() {
            $('#newsletterModal').modal('show');
            setCookie("kt_popupNewsletter",'disable',1,1,delay);
          }, 500);
        }
      }
    }
  }
  
  /* ---------------------------------------------
   STICKY ADD CART 
   --------------------------------------------- */
  function stickyAddCart(){
    if ($(window).width() > 768 && $("#cart_form_sticky").attr('data-only-variant') == 'true') {
      var $variation_form_sticky = $('#cart_form_sticky');
      $variation_form_sticky.on('click', '.swatch_list_sticky > .swatch_sticky', function(e) {
        e.preventDefault();
        var value = $(this).data('val'),
            inventory = $(this).data('inventory'),
            img_st = $(this).data('img'),
            $sticky_img = $('#pr_img_sticky>img'),
            $quantity_sticky = $('#quantity_sticky');
        $variation_form_sticky.find('select#productselect-sticky').val(value).trigger('change');
        $(this).parent().find('.selected').removeClass('selected');
        $(this).addClass('selected');
        if(typeof inventory !== 'undefined') {
          $quantity_sticky.html("Hurry, only 1 left in stock!".replace('1', inventory)).removeClass('hide');
          $('#number_sticky').attr('max',inventory);
        }else{
          $quantity_sticky.addClass('hide');
          $('#number_sticky').attr('max','1');
        }
        if(typeof img_st !== 'undefined') {
          $sticky_img.attr("src", img_st);
        }
      });
    }
  }
  
  function simpleDropdown() {
    $('.input-dropdown-inner').each(function() {
      var dd = $(this);
      var btn = dd.find('> a');
      var input = dd.find('> input');
      var list = dd.find('> ul'); //.dd-list-wrapper

      $(document).click(function(e) {
        var target = e.target;
        if (dd.hasClass('dd-shown') && !$(target).is('.input-dropdown-inner') && !$(target).parents().is('.input-dropdown-inner')) {
          hideList();
          return false;
        }
      });

      btn.on('click', function(e) {
        e.preventDefault();
        if (dd.hasClass('dd-shown')) {
          hideList();
        } else {
          $('.input-dropdown-inner.dd-shown > ul').show(100);
          $('.input-dropdown-inner.dd-shown').removeClass('dd-shown');
          showList();
        }
        return false;
      });

      function showList() {
        dd.addClass('dd-shown');
        list.slideDown(100);
      }

      function hideList() {
        dd.removeClass('dd-shown');
        list.slideUp(100);
      }
    });

    $('.swatch_sticky').each(function() {
      var btn = $(this);
      btn.on('click', function(e) {
        e.preventDefault();
        $('#idForm').val($(this).attr('data-val'));
        if($(this).attr('data-img') !== undefined ){
          $('#pr_img_sticky img').attr('src',$(this).attr('data-img'));
        }
        $('.swatch_sticky').removeClass('selected');
        $(this).addClass('selected');
        var label = $(this).find('a label').text() + ' - ' + $(this).find('a span').text();
        $('#labelDropdown').text(label);
      });
    });
  }
  
  
  /* ---------------------------------------------
   HEUGHT FULL
   --------------------------------------------- */
  function js_height_full(){
    (function($){
      var height = $(window).outerHeight();
      $(".full-height").css("height",height);
    })(jQuery);
  }
  function js_width_full(){
    (function($){
      var width = $(window).outerWidth();
      $(".full-width").css("width",width);
    })(jQuery);
  }
  
  /* ---------------------------------------------
     Scripts ready
   --------------------------------------------- */
  $(document).ready(function() {
    MasoryFilter();
    kt_quickView();
    kt_quickShop();
    if($('.searchDrop').first().attr('data-use') == 'true'){
      kt_search();
    }
    kt_countdown();
    kt_parallax();
    block_category_carousel();
    customize_error();
    instagram();
    addwishlist();
    removewishlist();
    realTimeVisitor();
    if($('.widget_recent_product').length > 0 || $('#ProductSection-product-template').length > 0){
      recentlyViewedAdd();
    }
    recentlyViewedListSidebar();
    responsive_item_slide();
    processbar();
    simpleDropdown();    
    AutoloadCompare();
    AddCompare();
    RemoveCompare();

    // Scroll top Top
    $(document).on('click','.scrollToTop',function() {
      $('body,html').animate({scrollTop:0},800);
    });

    // MENU SIDEBAR
    $(document).on('click','#header .close-header-sidebar',function(){
      $(this).closest('#header').addClass('closed').removeClass('opened');
    })
    $(document).on('click','#header .open-header-sidebar',function(){
      $(this).closest('#header').removeClass('closed').addClass('opened');
    });

    $(document).on('click','.header-categoy-menu .close-header-sidebar',function(){
      $(this).closest('.header-categoy-menu').addClass('closed').removeClass('opened');
    })
    $(document).on('click','.header-categoy-menu .open-header-sidebar',function(){
      $(this).closest('.header-categoy-menu').removeClass('closed').addClass('opened');
    });

    //Accordion mobile menu
    $('#mobile-menu ul li.has-sub').append('<span class="holder"></span>');
    $(document).on('click','.holder',function(){
      var element = $(this).closest('li');
      if (element.hasClass('open')) {
        element.removeClass('open');
        element.find('li').removeClass('open');
        element.find('ul').slideUp();
      }
      else {
        element.addClass('open');
        element.children('ul').slideDown();
        element.siblings('li').children('ul').slideUp();
        element.siblings('li').removeClass('open');
        element.siblings('li').find('li').removeClass('open');
        element.siblings('li').find('ul').slideUp();
      }
    });

    $('body').on('click','.modal-content .main-image img',function(event){
      event.preventDefault();
    });    
    
    //VIDEO LIGHTBOX
    if ( $('.video-lightbox .link-lightbox, .post-thumbnail a.link-lightbox').length ){
      $('.video-lightbox .link-lightbox, .post-thumbnail a.link-lightbox').simpleLightboxVideo();
    }
    
    $(document).on('click', '.fake_select label', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if($(this).parents('.fake_select').hasClass('show')){
        $('.fake_select.show').removeClass('show');
      }else{
        $('.fake_select.show').removeClass('show');
        $(this).parents('.fake_select').addClass('show');
      }
    });
    
    $(document).on("click", function(e) {
      if ($(e.target).is('.fake_select') === false) {
        $('.fake_select').removeClass("show");
      }
    });
    
    $(document).on('click', '.play-lifestyle-video', function(e) {
      e.preventDefault();
      $(this).parents('.photos-slider--active').toggleClass('show-video')
    });
    
    
    $(document).on('click', '.photos-slider--active .icon-play-video', function(e) {
      e.preventDefault();
      var vid = document.getElementById("myVideo");
      vid.play(); 
    });
    
    $(document).on('click', '.photos-slider--active svg.icon-close', function(e) {
      e.preventDefault();
      var vid = document.getElementById("myVideo");
      vid.pause(); 
    });
    
    $(document).on('change', '.cart__popup-quantity input.qty' ,function(){
      var pid = parseInt($(this).attr('data-pid')),
          quantity = parseInt($(this).val());
      if(quantity == 0){
        Shopify.KT_removeItem(pid,Shopify.KT_updatePopup);
        $(this).val(1);
      }
      else{
        Shopify.KT_changeItem(pid,quantity,Shopify.KT_updatePopup);
      }
    });
    
    $(document).on('focusout', '#CartSpecialInstructions' ,function(){
      $('#cartModal .checkout-button').prop('disabled', true);
      Shopify.KT_updateCartNote($(this).val(),Shopify.KT_updatedCartNote);
    });
    
    var $val_input = null;
    $(".box-search input.search").keyup(function(event) {
      event.preventDefault();
      if($('.searchDrop').first().attr('data-use') == 'true'){
        $val_input = $(this).val();
        ajaxSearch($(this))
      }
    });

    $(document).on('click','.scroll_top',function() {
      $('body,html').animate({scrollTop:0},800);
    });
    
    // Select image product
    $(document).on('click','.block-single-product .attributes .item span',function(){
      var image = $(this).data('image');
      var vrid = $(this).data('vrid');
      if( typeof image == undefined || image == ""){
        return false;
      }
      if( typeof vrid == undefined || vrid == ""){
        return false;
      }
      $(this).closest('.block-single-product').find('.product-image img').attr('src',image);
      $(this).closest('.block-single-product').find('.addtocart').attr('onclick',"Shopify.KT_addItem('"+vrid+"',1)");
      return false;
    })

    // Select image product gird
    $(document).on('click','li.grid-item .attributes .item span',function(){
      var image = $(this).data('image'),vrid = $(this).data('vrid'),vrprice = $(this).data('vrprice'),vrcompareprice = $(this).data('vrcompareprice');
      if( typeof image == undefined || image == ""){
        return false;
      }
      if( typeof vrid == undefined || vrid == ""){
        return false;
      }
      $(this).closest('.product-inner').find('.attributes .swatch-on-grid').removeClass('active');      
      $(this).closest('.product-inner').find('.price ins').html(theme.Currency.formatMoney(vrprice, theme.moneyFormat));
      console.log(vrcompareprice)
      var pr_vrcompareprice = $(this).closest('.product-inner').find('.price del');
      if(vrcompareprice != undefined && vrcompareprice != null && vrcompareprice != ''){
        pr_vrcompareprice.removeClass('hidden').html(theme.Currency.formatMoney(vrcompareprice, theme.moneyFormat));
      }else{
        if(pr_vrcompareprice.hasClass('hidden') === false){pr_vrcompareprice.addClass('hidden')}
      }      
      if(cookieCurrency !== null && cookieCurrency !== shopCurrency){
        Currency.convertAll(shopCurrency,cookieCurrency,'.product-inner span.money');
      }
      $(this).parent().addClass('active');
      var width = $(this).closest('.product-inner').find('.front-image').width();
          width = (Modernizr.touch) ? width * 2 : width;
      $(this).closest('.product-inner').find('.front-image').html('<img src="'+image.replace('_480x','_'+width+'x')+'" alt="'+$(this).data('vrtitle')+'">');
      $(this).closest('.product-inner').find('.boutique__add-to-cart').attr('onclick',"Shopify.KT_addItem('"+vrid+"',1);$(this).addClass('loading').removeClass('loaded')");
      return false;
    })
    
    $(document).on('submit', "form#layered_form,form#layered_form_clone", function(event){
      event.preventDefault();
    });
//     $(".box-search input.search").change(function(event) {
//       event.preventDefault();
//       if($(this).val() !== $val_input){
//         ajaxSearch($(this))
//       }
//     });
    
    // Create an event listener to set a specific variant option when clicking on swatches.
    $(document).on('click', '[data-change-option]', function(e) {      
      //Single product page    
      var templateSinglePr = 'product-template';
      if($(this).parents('.product-page').length > 0){
        templateSinglePr = $(this).parents('.product-page').attr('data-section-id');
      }
      e.preventDefault();
      goto = true;
      var optionIndex = $(this).data('change-option');
      optionValue = $(this).data('value');
      first_available = $(this).data('first-variant');
      first_available_title = $(this).data('first-variant-title');
      $(this).parent().find('li').removeClass('selected');
      $(this).addClass('selected');
      $("#ProductSection-"+templateSinglePr+" #"+optionIndex).val(optionValue).trigger('change');
      $("#ProductSection-"+templateSinglePr+" label[data-change-label='"+optionIndex+"'] .text").html(optionValue);
      $("#ProductSection-"+templateSinglePr+" .swatches-selected-name[data-change-label='"+optionIndex+"'] .name").html(optionValue);
      $('#ProductSection-'+templateSinglePr+' .fake_select.show').removeClass('show');
    });
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    if (Modernizr.touch == false){
      $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery').zoom({url: $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery .product-single__photos-item.slick-active').attr('data-src')});
      $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery').trigger('zoom.destroy'); // remove zoom
        $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery').zoom({url: $('#ProductSection-'+templateSinglePr+' .SlickPhotoswipGallery .product-single__photos-item.slick-active').attr('data-src')});
      });
      $(document).on('click', 'img.zoomImg', function(event) {
        event.preventDefault();
        $('#ProductSection-'+templateSinglePr+' .product-single__photos-item.slick-slide.slick-current.slick-active').trigger('click');
      });
    }
  });  
  /* ---------------------------------------------
   Scripts initialization
   --------------------------------------------- */
  $(window).load(function() {
    scrollbar_header_sidebar();    
    if($('#instafeed, #instafeed_1').length > 0){
      $('#instafeed li:empty, #instafeed_1 li:empty').remove();
      $('#instafeed, #instafeed_1').removeClass('hidden');
    }
  });
    
  document.addEventListener("DOMContentLoaded", function(event) {
    // product-card-list nosidebar
    $('.listThumbScroll').each(function(){
      $(this).css('height',$(this).height()+'px');
      $(this).find('.ab').removeClass('ab');
      $(this).mThumbnailScroller({
        axis:"y", //change to "y" for vertical scroller
        type:"hover-precise"
      });
    })
    
    var dataScrollNewsletterPopup = parseInt($('#newsletterModal').attr('data-scroll'));
    if( dataScrollNewsletterPopup == 0 ){
      checkCookieNewsletterPopup();
    }
    recentlyViewedProductSingle();
  });
  
  /* ---------------------------------------------
   Scripts scroll
   --------------------------------------------- */
  $(window).scroll(function() {
    // Show hide scrolltop button
    var windowHeight = $(window).height();
    if($(this).scrollTop() > windowHeight ) {
      $('.scroll_top').fadeIn(500);
    } else {
      $('.scroll_top').fadeOut(800);
    }
    // Show hide newletter
    var dataScrollNewsletterPopup = parseInt($('#newsletterModal').attr('data-scroll'));
    if( $(window).scrollTop() >= dataScrollNewsletterPopup && dataScrollNewsletterPopup != 0 ){
      checkCookieNewsletterPopup();
    }
    // Show hide sticky tool bar
    if($(window).scrollTop() > $('#header').offset().top) {
      stickyToolbar('up');
    } else {
      stickyToolbar('down');
    }
    if($(window).scrollTop() > $('#header').offset().top + 40) {
      stickyToolbar('up');
    } else {
      stickyToolbar('down');
    }
    // Show hide sticky add to card
    if($('#AddToCartText-product-template').length){
      if ($(window).scrollTop() > $('#AddToCartText-product-template').offset().top + 60 && $('.jas-sticky-atc').not('.fixed')) {
        $('.jas-sticky-atc').addClass('fixed');
        $('body').addClass('add_sticky_nt');
      }
      else if($(window).scrollTop() <= $('#AddToCartText-product-template').offset().top){
        $('.jas-sticky-atc').removeClass('fixed');
        $('body').removeClass('add_sticky_nt');
      }
    }
  });
  
  /* ---------------------------------------------
   Scripts resize
   --------------------------------------------- */
  $(window).on("resize", function() {
    scrollbar_header_sidebar();
    // product-card-list nosidebar
    $('.listThumbScroll').each(function(){
      var height = $(this).parent().find('.product-thumb .front-image img').height();
      $(this).css('height',height+'px');
    });
  });
//   var lastScrollTop = 0;
//   $(window).on('scroll', function() {
//     var st = $(this).scrollTop();
//     if(st < lastScrollTop + 40) {
//       stickyToolbar('up');
//     }
//     else if(st > lastScrollTop - 40) {
//       stickyToolbar('down');
//     }
//     lastScrollTop = st;
//   });
  
//   $('body').on('mousewheel', function(e){
//     if(e.originalEvent.wheelDelta > 0) {
//       stickyToolbar('up');
//     }
//     else {
//       stickyToolbar('down');
//     }
//   });
  
  if ($.support.pjax) {
    $(document).on('click', 'a[data-pjax]', function(event) {
      $.pjax.click(event, {
        container: '#MainContent',
        fragment: '#MainContent',
        timeout: 4000,
        scrollTo: false
      })
    });
  }
  
  $(document).on('pjax:send', function() {
//     alert('send');
  })
  
  $(document).on('pjax:complete', function() {
    var sections = new theme.Sections();
    sections.register('cart-template', theme.Cart);
    sections.register('product', theme.Product);
    sections.register('collection-template', theme.Filters);
    sections.register('header-section', theme.HeaderSection);
    sections.register('map', theme.Maps);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('carousel-section', theme.CarouselSection);
    sections.register('masory-section', theme.MasorySection);
    sections.register('quotes', theme.Quotes);
    theme.variantImage();
    theme.menuBgChange();
    window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
  })
})( jQuery );